import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Button } from './ui/button';
import { X } from 'lucide-react';

/** Employee / project filters for the weekly timesheet rows (view only, never remembered). */
export const TimesheetRowFilters = ({ entries, employees, projects, employee, setEmployee, project, setProject, shown }) => {
  const { t } = useTranslation();
  const empIds = [...new Set(entries.map((e) => e.employee_id).filter(Boolean))];
  const projIds = [...new Set(entries.map((e) => e.project_id).filter(Boolean))];
  const empName = (id) => employees.find((e) => e.id === id)?.name || id;
  const projName = (id) => projects.find((p) => p.id === id)?.name || id;
  const active = employee !== 'all' || project !== 'all';
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2" data-testid="timesheet-row-filters">
      <Select value={employee} onValueChange={setEmployee}>
        <SelectTrigger className="h-9 w-[240px] max-w-full" data-testid="timesheet-employee-filter"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('timesheetFilters.allEmployees')}</SelectItem>
          {empIds.map((id) => <SelectItem key={id} value={id}>{empName(id)}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={project} onValueChange={setProject}>
        <SelectTrigger className="h-9 w-[240px] max-w-full" data-testid="timesheet-project-filter"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('timesheetFilters.allProjects')}</SelectItem>
          {projIds.map((id) => <SelectItem key={id} value={id}>{projName(id)}</SelectItem>)}
        </SelectContent>
      </Select>
      {active && (
        <>
          <span className="text-xs text-gray-500" data-testid="timesheet-filter-count">
            {t('timesheetFilters.showing', { shown, total: entries.length })}
          </span>
          <Button variant="ghost" size="sm" className="h-8 px-2 text-red-600" data-testid="timesheet-filters-clear"
            onClick={() => { setEmployee('all'); setProject('all'); }}>
            <X className="h-4 w-4 mr-1" />{t('timesheetFilters.clear')}
          </Button>
        </>
      )}
    </div>
  );
};

export default TimesheetRowFilters;
